/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowProcessEntity } from './WorkflowProcessEntity';
import {
    WorkflowProcessEntityFromJSON,
    WorkflowProcessEntityFromJSONTyped,
    WorkflowProcessEntityToJSON,
    WorkflowProcessEntityToJSONTyped,
} from './WorkflowProcessEntity';

/**
 * 
 * @export
 * @interface ListWorkflowProcessesResult
 */
export interface ListWorkflowProcessesResult {
    /**
     * プロセス一覧
     * @type {Array<WorkflowProcessEntity>}
     * @memberof ListWorkflowProcessesResult
     */
    processes: Array<WorkflowProcessEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListWorkflowProcessesResult
     */
    total: number;
}

/**
 * Check if a given object implements the ListWorkflowProcessesResult interface.
 */
export function instanceOfListWorkflowProcessesResult(value: object): value is ListWorkflowProcessesResult {
    if (!('processes' in value) || value['processes'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListWorkflowProcessesResultFromJSON(json: any): ListWorkflowProcessesResult {
    return ListWorkflowProcessesResultFromJSONTyped(json, false);
}

export function ListWorkflowProcessesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWorkflowProcessesResult {
    if (json == null) {
        return json;
    }
    return {
        
        'processes': ((json['processes'] as Array<any>).map(WorkflowProcessEntityFromJSON)),
        'total': json['total'],
    };
}

export function ListWorkflowProcessesResultToJSON(json: any): ListWorkflowProcessesResult {
    return ListWorkflowProcessesResultToJSONTyped(json, false);
}

export function ListWorkflowProcessesResultToJSONTyped(value?: ListWorkflowProcessesResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processes': ((value['processes'] as Array<any>).map(WorkflowProcessEntityToJSON)),
        'total': value['total'],
    };
}

